import { Button } from 'blaze-ui/Button'
import { Calendar2 } from 'blaze-ui/icons'
import { ScheduleDateTimeDrawer } from '../ScheduleDateTimeDrawer/ScheduleDateTimeDrawer'
import { useRootStore } from 'stores/RootStore'
import dayjs from 'dayjs'
import Styles from './DatePickerButton.module.scss'

interface DatePickerButtonProps {
  value?: Date
  onChange: (date: Date | undefined) => void
  placeholder?: string
  showTimeControls?: boolean
  allowPastDates?: boolean
  hideTimePicker?: boolean
  size?: 'sm' | 'md' | 'lg' | 'xl'
  variant?: 'primary' | 'secondary' | 'tertiary'
  fullWidth?: boolean
  className?: string
  hideTimeDisplay?: boolean
}

export const DatePickerButton = ({
  value,
  onChange,
  placeholder = 'Select date & time',
  hideTimePicker = false,
  size = 'xl',
  variant = 'tertiary',
  fullWidth = true,
  className,
  hideTimeDisplay = false,
}: DatePickerButtonProps) => {
  const { drawersStore } = useRootStore()

  const handleOpenDatePicker = () => {
    const defaultDate = value || dayjs().add(1, 'day').toDate()
    drawersStore.openDrawer(ScheduleDateTimeDrawer, {
      selectedDate: defaultDate,
      hideTimePicker,
      onDateSelect: (date: Date) => {
        onChange(date)
        drawersStore.closeDrawer()
      },
    })
  }

  const getDisplayContent = () => {
    if (!value) return <span className={Styles.dateLabel}>{placeholder}</span>

    if (hideTimeDisplay) return <span className={Styles.dateLabel}>{dayjs(value).format('MMM D, YYYY')}</span>

    return (
      <div className={Styles.dateTimeText}>
        <span className={Styles.datePart}>{dayjs(value).format('MMM D, YYYY')}</span>
        <span className={Styles.timePart}>{dayjs(value).format('h:mmA')}</span>
      </div>
    )
  }

  return (
    <Button
      size={size}
      variant={variant}
      fullWidth={fullWidth}
      onPress={handleOpenDatePicker}
      className={`${Styles.dateButton} ${className || ''}`}
      useChildClass
    >
      <div className={Styles.info}>
        <Calendar2 />
        {getDisplayContent()}
      </div>
    </Button>
  )
}
